export default {
  contained: {
    boxShadow:
    '0 0 10px 0px rgba(63,63,68,0.05)',
    backgroundColor: '#FFFFFF'
  }
};
